import http from 'hub-http/clients/apiClient';
import { COMPANY_TYPE_ID, CONTACT_TYPE_ID, DEAL_TYPE_ID, TICKET_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';

// supported object types for prosemirror plugins
export const baseAssociationsObject = {
  [COMPANY_TYPE_ID]: 'companyIds',
  [CONTACT_TYPE_ID]: 'contactIds',
  [DEAL_TYPE_ID]: 'dealIds',
  [TICKET_TYPE_ID]: 'ticketIds'
};
export const fetchEngagementAssociationsSummary = (objectId, objectTypeId) => {
  return http.post('crm/events/v3/engagement-associations', {
    data: {
      limitPerAssociationType: 50,
      objectId,
      objectTypeId
    }
  });
};
export const getAssociatedObjectIds = ({
  objectTypeId,
  summaryAssociations
}) => {
  if (!summaryAssociations) {
    return [];
  }
  const associatedObjects = summaryAssociations[objectTypeId];
  if (!associatedObjects) {
    return [];
  }
  return associatedObjects.reduce((acc, {
    id
  }) => {
    acc.push(id);
    return acc;
  }, []);
};
export const hasAssociationToObject = ({
  objectId,
  objectTypeId,
  summaryAssociations
}) => {
  var _summaryAssociations$;
  return !!(summaryAssociations !== null && summaryAssociations !== void 0 && (_summaryAssociations$ = summaryAssociations[objectTypeId]) !== null && _summaryAssociations$ !== void 0 && _summaryAssociations$.some(({
    id
  }) => id === objectId));
};